import { TextField, Button, Box } from "@mui/material";
import { IChangePassword } from 'interfaces';
import { handleChangeStateInput } from 'lib/common/handle-change-state';
import { styled } from "@mui/material/styles";

const SignSubmitButton = styled(Button)({
  marginTop: 2,
  flexGrow: 1,
  textTransform: "none",
});

interface ChangePasswordProps {
  isLoading: boolean
  passwordData: IChangePassword
  setPasswordData: React.Dispatch<React.SetStateAction<IChangePassword>>
  handleChangePassword: Function
}

const ChangePassword = ({ isLoading, handleChangePassword, setPasswordData, passwordData }: ChangePasswordProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "10px 0px", alignItems: "stretch", width: "100%" }}>
      <form noValidate  onSubmit={(e) => {
        e.preventDefault();
        handleChangePassword();
      }}>
        <TextField
          sx={{ backgroundColor: "#ffffff" }}
          name="password"
          variant="outlined"
          required
          fullWidth
          label="パスワード"
          type="password"
          value={passwordData.password}
          margin="dense"
          onChange={handleChangeStateInput(setPasswordData)}
        />
        <TextField
          sx={{ backgroundColor: "#ffffff" }}
          name="password_confirmation"
          variant="outlined"
          required
          fullWidth
          label="パスワード確認"
          type="password"
          value={passwordData.password_confirmation}
          margin="dense"
          onChange={handleChangeStateInput(setPasswordData)}
        />
        <SignSubmitButton
          type="submit"
          variant="contained"
          size="large"
          fullWidth
          color="primary"
          disabled={!passwordData.password || !passwordData.password_confirmation || isLoading}
        >
          送信
        </SignSubmitButton>
      </form>
    </Box>
  )
}

export default ChangePassword
